// extracted by mini-css-extract-plugin
export var productImage = "_hn-1";
export var viewLink = "_hn-2";
export var wishlistItem = "_hn-0";